import React, { useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthSessionContext } from '@context/AuthContext'
import { BaseModalType } from '@context/ModalsContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { Modal } from '@ui/components/Modal'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'
import { formatDate } from '@utils/date.utils'

import { useFetchOne } from '@hooks/useFetch'

import { StatusBadge, SubscriptionBadgeMap } from '@shared/components/StatusBadge/StatusBadge'

interface Props {
  id: string
}

export const SubscriptionStatusHistoryModal: BaseModalType<Props> = (props) => {
  const { id, close } = props
  const { t } = useTranslation()
  const [auth] = useContext(AuthSessionContext)
  const apiClient = useApiClient(ClientApiClient)
  const dateFormat = auth?.dateFormatType?.name
  const locale = useSessionLanguage()

  const historyCallback = useCallback(
    () => apiClient.getSubscriptionStatusHistory(id, locale),
    [apiClient, id, locale]
  )
  const { data, isLoading } = useFetchOne(historyCallback)

  const parsedData = data?.map((item) => ({
    badge: <StatusBadge badgeMap={SubscriptionBadgeMap} {...item} />,
    title: `${t('Date')}: ${formatDate(item.created, { formatType: dateFormat })}`,
  }))
  return (
    <Modal>
      <Modal.Header>{t('Status History')}</Modal.Header>
      <Modal.Body isLoading={isLoading}>
        <Modal.Body.Status statuses={parsedData} />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
